import React, { useState, useEffect } from "react";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { authProvider } from "./authProvider";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CareerSettingsPortal from "./Pages/CareerSettingsPortal";
import { CircularProgress, Box } from '@mui/material'; // Import CircularProgress from Material-UI
import './App.css';
import SessionExpirationPopup from "./Pages/SessionExpirationPopup";

function App() {
  const [sessionExpired, setSessionExpired] = useState(false);
  const [lastActivity, setLastActivity] = useState(Date.now());

  const handleUserActivity = () => {
    setLastActivity(Date.now());
  };

  useEffect(() => {
    document.addEventListener("mousemove", handleUserActivity);
    document.addEventListener("keydown", handleUserActivity);

    return () => {
      document.removeEventListener("mousemove", handleUserActivity);
      document.removeEventListener("keydown", handleUserActivity);
    };
  }, []);
  const handleClosePopup = () => {
    setSessionExpired(false);
  };
  useEffect(() => {
    const checkSession = setInterval(() => {
      const currentTime = Date.now();
      const sessionTimeout = 30 * 60 * 1000; // 30 minutes
      if (currentTime - lastActivity > sessionTimeout) {
        setSessionExpired(true);
      } else {
        setSessionExpired(false);
      }
    }, 300000); // Check every 5 minutes

    return () => clearInterval(checkSession);
  }, [lastActivity, sessionExpired]);

  return (
    <div className="App">
      <ToastContainer />
      <AzureAD provider={authProvider} forceLogin={false}>
        {({ login, logout, authenticationState, error, accountInfo }) => {
          switch (authenticationState) {
            case AuthenticationState.Authenticated:
              console.log("accountInfo", accountInfo.account.name);
              // const userName = accountInfo.account.name;
              if (sessionExpired) {
                return (
                  <SessionExpirationPopup sessionExpired={sessionExpired} onLogin={login} onClose={handleClosePopup} />
                );
              }

              return (
                <div>
                  {/* Call the CareerSettingsPortal Component */}
                  <CareerSettingsPortal accountInfo={accountInfo} logout={logout} />
                </div>
              );

            case AuthenticationState.Unauthenticated:
             login();
             return<></>;

            case AuthenticationState.InProgress:
              return (
                <Box sx={styles.loaderContainer}>
                  <CircularProgress />
                </Box>
              );

            default:
              return <></>
          }
        }}
      </AzureAD>
    </div>
  );
}

const styles = {
  sessionExpiredContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f2f2f2',
  },
  sessionExpiredMessage: {
    textAlign: 'center',
    padding: '20px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    flexDirection: 'column',
  },
};

export default App;
